import { useTranslation } from 'react-i18next'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import HelpPanel from '../HelpPanel/HelpPanel'
import HelpScreenshot from '../HelpScreenshot/HelpScreenshot'
import VerifyDetailsHelp from '../VerifyDetailsHelp/VerifyDetailsHelp'
import WaitBox from '../WaitBox/WaitBox'
import { HELP_IMAGES } from '../helpImages'
import { JOURNEY_COPY } from '../fidelityJourney'
import type { EmailConnectionProps } from '../types'
import { StyledHelpNote, StyledScript } from '../styled-components'

const EmailConnection = ({ hidden }: EmailConnectionProps) => {
  const { t } = useTranslation()
  const isPulse = usePulseScope()

  if (hidden) {
    return null
  }

  return (
    <>
      <HelpPanel title={t(`${JOURNEY_COPY}.help.subject_title`)}>
        <StyledHelpNote dangerouslySetInnerHTML={{ __html: t(`${JOURNEY_COPY}.help.subject_body`) }} />
      </HelpPanel>
      <HelpPanel title={t(`${JOURNEY_COPY}.help.email_button_title`)}>
        <HelpScreenshot src={HELP_IMAGES.emailConsumptionButton} alt={t(`${JOURNEY_COPY}.help.email_button_alt`)} />
      </HelpPanel>
      <StyledScript $pulse={isPulse} dangerouslySetInnerHTML={{ __html: t(`${JOURNEY_COPY}.email.script`) }} />
      <VerifyDetailsHelp
        kicker={t(`${JOURNEY_COPY}.help.journey_kicker_email`)}
        src={HELP_IMAGES.webCheckDetails}
        alt={t(`${JOURNEY_COPY}.help.journey_email_alt`)}
      />
      <WaitBox text={t(`${JOURNEY_COPY}.email.waiting`)} />
      <SDNotification type='warning' primaryText={t(`${JOURNEY_COPY}.email.note`)} />
    </>
  )
}

export default EmailConnection
